export default __webpack_public_path__ + "static/media/subscription-cross.692f00d3.svg";